import debug from 'debug';

const log = debug('fus078/components/modal-block');

const ELEMENT_SELECTOR = '[data-modal]';

$(document).on('ready markupLoaded', () => {
	const $element = $(ELEMENT_SELECTOR);
	if ($element && $element.length > 0) {
		System.import(
			/* webpackChunkName: "vendor/ModalWindowEffects/js/modalEffects" */
			'@vendor/ModalWindowEffects/js/modalEffects.js')
			.then(() => {
				log("ModalWindowEffects.loaded");
			});
	}
});


// WEBPACK FOOTER //
// ./client/src/site__fus078/components/blocks/modal/index.js